import { render } from "./vagentlistedit.vue?vue&type=template&id=ed3b24c8&scoped=true"
import script from "./vagentlistedit.vue?vue&type=script&lang=js"
export * from "./vagentlistedit.vue?vue&type=script&lang=js"

import "./vagentlistedit.vue?vue&type=style&index=0&id=ed3b24c8&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境商户后台shop.jsyinba.com/jsmerchant/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed3b24c8"]])

export default __exports__